import { loadScriptInHead } from '../../utils/dom';
import { EDITION_ID_EN_GB } from '../../constants';

const PINTEREST_UK_TAG_ID = '2612364440876';

export default function Pinterest(edition_data) {
  loadScriptInHead('statistics', 'https://assets.pinterest.com/js/pinit.js', { attrs: {
    "data-pin-custom": true,
    "data-pin-build": "refreshPinterestEmbeds"
  }});

  if (edition_data.id === EDITION_ID_EN_GB) {
    loadScriptInHead('statistics', 'https://s.pinimg.com/ct/core.js');

    if (!window.pintrk) {
      window.pintrk = function() {
        window.pintrk.queue.push(
          Array.prototype.slice.call(arguments));
      };
      var n = window.pintrk;
      n.queue = [], n.version = "3.0";
    }

    window.pintrk('load', PINTEREST_UK_TAG_ID);
    window.pintrk('track', 'pagevisit');
  }
}
